import './Snow.css';
const Snow = (props) => {
  return (
    <div
      onClick={props.onClick}
      className={`snow ${props.stateSnow ? 'active' : ''}`}
    >
      <img
        className="snow__img"
        src="/images/icons/snow.png"
        alt="Icono copo de nieve"
      ></img>
    </div>
  );
};

export default Snow;
